import { useBlockProps, InnerBlocks } from "@wordpress/block-editor";

export default function save({ attributes }) {
  const { displayType } = attributes;

  const blockProps = useBlockProps.save();

  return (
    <div {...blockProps}>
      {displayType === "popup" && <InnerBlocks.Content />}
    </div>
  );
}

